import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import type { SectionTypeVersion } from '../../types';

export type { SectionTypeVersion };

async function fetchSectionTypeVersion(id: string, version: number) {
  const { data } = await axiosPrivate.get<SectionTypeVersion>(
    `/v3/pharmacist/section-types/${id}/versions/${version}`
  );
  return data;
}

export function useGetSectionTypeVersion({ id, version }: { id: string; version: number }) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['section-type-version', id, version],
    queryFn: () => fetchSectionTypeVersion(id, version),
    enabled: !!id,
    meta: { errorMessage: 'Failed to load section type details' },
  });

  return { sectionTypeData: data, isLoading, isError, error };
}
